import { createAsyncThunk } from '@reduxjs/toolkit';

import { GrazingService } from '../../services';

export const fetchGrazingData = createAsyncThunk(
  'grazing/fetchGrazingData',
  async ({ date, rotationIds }, { rejectWithValue }) => {
    try {
      const response = await GrazingService.fetchGrazingData({ date, rotationIds });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch fetch grazing data');
    }
  }
);

export const fetchGrazingHeatmapStyles = createAsyncThunk(
  'grazing/fetchGrazingHeatmapStyles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GrazingService.fetchGrazingHeatmapStyles();

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch fetch grazing heatmap styles');
    }
  }
);
